import React from "react";

export default function WindowIcon() {
  return (
    <div className=" absolute left-0 top-3">
      <svg className="h-3 " viewBox="0 0 252 64">
        <g fill="none" fillRule="evenodd">
          <g fill="#666">
            <circle id="Oval" cx="32" cy="32" r="32" fill="#F93D3D"></circle>
            <circle
              id="Oval-Copy"
              cx="126"
              cy="32"
              r="32"
              fill="#FAC418"
            ></circle>
            <circle
              id="Oval-Copy-2"
              cx="220"
              cy="32"
              r="32"
              fill="#29D083"
            ></circle>
          </g>
        </g>
      </svg>
    </div>
  );
}
